const dashboardPage            = require('./suggestion-page')
const quickviewSuggestion        = require('./suggestion-quickview')

export function start(detail){  //console.log('nurses-dt 5>', detail)
         
      obj[detail.elem].start(detail)
}/**/

const obj = {
   
      page:            { start: (detail)=>{  dashboardPage.start(detail)             }},
      quickview:       { start: (detail)=>{  quickviewSuggestion.start(detail)       }},
}/**/